import { render, staticRenderFns } from "./DisplaySkill.vue?vue&type=template&id=045d3440&scoped=true"
import script from "./DisplaySkill.vue?vue&type=script&lang=js"
export * from "./DisplaySkill.vue?vue&type=script&lang=js"
import style0 from "./DisplaySkill.vue?vue&type=style&index=0&id=045d3440&prod&scoped=true&lang=css"
import style1 from "./DisplaySkill.vue?vue&type=style&index=1&id=045d3440&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045d3440",
  null
  
)

export default component.exports